import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import Request from '../../networkReq/request';
import PagingContent from 'components/PagingContent'
require("./index.css");


export default class SoldierConsulting extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      navNum: '',
    //查询参数
      params:{
        type:3,
        size:10
      }
    };
  }

  renderList(data){
    if(data==''||!data.records){
      return '';
    }
    let records = data.records;
    return (
     <ul>
          {records.length != 0 ? records.map((item,index) => {
          return (
            <li key={index}>
              <Link to={"/entrance/InformationDetails?" + item.id}>
              <div className="content_list_dot"></div>
              <div className="content_list_txt">{item.title}</div>
              <div className="content_list_time">{item.createTime.split(" ")[0]}</div>
            </Link>
            </li>
          )
          }):''
        }
     </ul>
    )
  }

  render() {
    return (
      <div className="content_list">
        <PagingContent   requestUrl={Request.getDynamicInfo()} renderList={this.renderList} params={this.state.params}/>
      </div>
    );
  }
}
